import { articleLanguage, articlePath } from "../lib/articleLanguage";
import { usePublicLanguage } from "../context/PublicLanguage";
import React from "react";
import { Link } from "react-router-dom";
import ReadingTime from "./ReadingTime";
import CategoryTag from "@/components/CategoryTag";
import { timeAgo } from "@/lib/format";

export default function StoryCard({ article, size = "md", showExcerpt = true, showImage = true, featured = false }) {
  const { t, language } = usePublicLanguage();
  const selected = articleLanguage(article, language);
  article = selected.article;
  const to = articlePath(article, selected.language);
  const isLarge = size === "lg";
  const isSmall = size === "sm";

  return (
    <article className={`group td-fade-up ${featured ? "category-featured" : ""}`} data-testid={`story-card-${article.slug}`}>
      <Link to={to} className={featured ? "category-featured-link" : "block"}>
        {showImage && (
          <div className={`relative overflow-hidden rounded-md mb-4 ${featured ? "category-featured-media" : ""}`} style={{ aspectRatio: featured ? "16/9" : isSmall ? "16/10" : "16/9", background: "#111315" }}>
            <img
              src={article.hero_image}
              alt={article.hero_alt || article.headline}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
            />
          </div>
        )}
        <div className="category-featured-copy">
        <div className="flex items-center gap-3 mb-2">
          <CategoryTag category={article.category} asLink={false} small />
        </div>
        {language === "id" && selected.language === "en" && <span className="text-xs text-[#FFB347]">English · Terjemahan belum tersedia</span>}
        <h3 lang={selected.language}
          className={`font-display font-bold leading-snug tracking-tight transition-colors duration-200 group-hover:text-[#FF8A1F] ${
            isLarge ? "text-2xl md:text-3xl" : isSmall ? "text-base" : "text-lg md:text-xl"
          }`}
          style={{ color: "#F5F5F2" }}
        >
          {article.headline}
        </h3>
        {showExcerpt && !isSmall && (
          <p lang={selected.language} className="mt-2 text-[#A7ABB0] leading-relaxed" style={{ fontSize: isLarge ? "1.05rem" : "0.98rem" }}>
            {article.excerpt}
          </p>
        )}
        </div>
      </Link>
      <div className="mt-3 flex items-center gap-3 td-eyebrow" style={{ color: "#71767c", fontSize: "0.62rem" }}>
        <span>{timeAgo(article.published_at, language)}</span>
        <ReadingTime article={article} />
        {article.author_detail && !isSmall && (
          <>
            <span className="opacity-40">/</span>
            <span className="truncate">{article.author_detail.name}</span>
          </>
        )}
      </div>
    </article>
  );
}
